import axios, { getData } from 'lib/axios'

export const getUpskillApprovalList = async (status, per_page, page) => {
  const response = await axios.get(
    `/upskilling/approval/approval-list?status=${status}&per-page=${per_page}&page=${page}`
  )
  return getData(response)
}
export const getAllUpskillProgression = async (per_page, page, search) => {
  const response = await axios.get(
    `/upskilling/approval/staff/enrollment?per-page=${per_page}&page=${page}${search}`
  )
  return getData(response)
}
export const getOneUpskillProgression = async (id) => {
  const response = await axios.get(`/upskilling/approval/staff/enrollment/${id}`)
  return getData(response)
}
export const getOneUpskillApprovalList = async (id) => {
  const response = await axios.get(`/upskilling/approval/${id}`)
  return getData(response)
}
export const postUpskillApproval = async (id, data) => {
  const response = await axios.post(`/upskilling/approval/action/${id}`, data)
  return getData(response)
}
